// Picks readable text/icon color for content sitting on top of a given
// background color, using the standard YIQ perceived-brightness heuristic.
export function getContrastColor(hex) {
  const match = /^#?([0-9a-f]{6})$/i.exec(hex || '');

  if (!match) {
    return '#ffffff';
  }

  const value = parseInt(match[1], 16);
  const r = (value >> 16) & 0xff;
  const g = (value >> 8) & 0xff;
  const b = value & 0xff;

  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  return yiq >= 150 ? '#111111' : '#ffffff';
}
